import { Injectable } from '@angular/core';
import {ConfigService} from "./config.service";
import {UserModel} from "../models/user.model";
import * as CryptoJS from 'crypto-js';
import {TitleService} from "./title.service";
import {countryData} from "../shared/modals/reg-modal/reg-step2/data";
import { ReplaySubject} from "rxjs";

const getUserGroup = (user_class: string) => Object.entries({
  "Adyen test": "Adyen",
  "Anna's Group - MEGAVIP": "Mega",
  "ARJEL - DO NOT OPEN": "CLOSED ACCOUNTS",
  "Benny VIP French": "VIP2",
  "Benny Vip NO CHAT": "VIP2",
  "Bonus High - High Wager": "VIP2",
  "Bonus Hunter": "VIP2",
  "Bonus Low – High Wager": "VIP2",
  "Bonus Medium - High Wager": "VIP2",
  "Bonus Player - Low": "VIP2",
  "Bonus Player - Medium": "VIP2",
  "CashBack - UK": "Risk",
  "CB or High Risk on Signup": "Risk",
  "Closed Account": "CLOSED ACCOUNTS",
  "CLOSED ACCOUNT": "CLOSED ACCOUNTS",
  "CLOSED ACCOUNTS": "CLOSED ACCOUNTS",
  "Danny VIP French": "VIP6",
  "Default": "VIP1",
  "Dendera Bonus Hunter": "VIP1",
  "Dendera Suspect Bonus Hunter": "VIP1",
  "DE - NR": "Real",
  "Depo #1": "VIP1",
  "DE - Star": "VIP1",
  "DE - VIP BRONZE - Lapsed": "VIP2",
  "DO NOT USE": "Risk",
  "DON'T USE": "CLOSED ACCOUNTS",
  "DUPLICATE-VIP-BENNY": "VIP2",
  "DUPLICATE-VIP-OLIVE": "VIP4",
  "EN - NR": "Real",
  "EN - Star": "VIP1",
  "EN - VIP BRONZE - NO PROMOTIONS": "VIP2",
  "ES - NR": "Real",
  "ES - Star": "VIP1",
  "Fake Reg": "Fake",
  "FR - NR": "Real",
  "FR - Star+": "VIP1",
  "FR - VIP BRONZE - Sleepy": "VIP2",
  "HIGH RISK - NO CC DEPs": "VIP1",
  "In_Review": "VIP1",
  "IT - NR": "Real",
  "J&J": "CLOSED ACCOUNTS",
  "LANG - NR": "Real",
  "LANG - Star": "VIP1",
  "Languages VIP": "VIP1",
  "Lapsed": "VIP1",
  "Lapsed 3": "VIP1",
  "Lapsed 4": "VIP1",
  "Laure CROSS": "VIP1",
  "Laure_VIP": "VIP1",
  "Low Bonus": "VIP2",
  "MEGA - Increased Daily Comp Points": "Mega",
  "MEGA VIP OG": "Mega",
  "MEGAVIP OG": "Mega",
  "MEGA VIP OG - DO NOT CHAT!": "Mega",
  "Mega VIP w/ Comps": "Mega",
  "New Fun": "Fun",
  "New Fun 2": "Fun",
  "New Fun 2 - Slots": "Fun",
  "New Fun 2 - Table": "Fun",
  "New Fun 3": "Fun",
  "New Fun 3 - Slots": "Fun",
  "New Fun 3 - Table": "Fun",
  "New Fun 4": "Fun",
  "New Fun 4 - Slots": "Fun",
  "New Fun 4 - Table": "Fun",
  "Real": "Real",
  "Real 2": "Real",
  "Real 2 - Slots": "Real",
  "Real 2 - Table": "Real",
  "Real 3": "Real",
  "Real 3 - Slots": "Real",
  "Real 3  - Table": "Real",
  "Real 3 - Table": "Real",
  "NOT IN USE": "CLOSED ACCOUNTS",
  "**NOT USED**": "CLOSED ACCOUNTS",
  "NR EN - US": "Real",
  "NWH - ENG (No Dep)": "CLOSED ACCOUNTS",
  "On Retention": "CLOSED ACCOUNTS",
  "Risk Dep - Default": "Risk",
  "Rival Global Bonus Ban Linked": "CLOSED ACCOUNTS",
  "Rival Wide Internal Links": "Risk",
  "Steel": "VIP1",
  "Suspect Bonus Hunter": "VIP1",
  "Test": "TEST",
  "Test Account": "TEST",
  "Test Account 2": "TEST",
  "Testtest": "TEST",
  "US - Lapsed": "VIP1",
  "US not eligible for bonuses": "VIP1",
  "VIP": "VIP1",
  "VIP 1 (No Docs / No WD)": "VIP1",
  "VIP 1 (Risk - Active)": "VIP1",
  "VIP 1 (Risk - Lapsed)": "VIP1",
  "VIP 1 (Slots - Active)": "VIP1",
  "VIP 1 (Slots - Lapsed)": "VIP1",
  "VIP 1 (Slots - Sleepy)": "VIP1",
  "VIP 1 (Table - Active)": "VIP1",
  "VIP 1 (Table - Lapsed)": "VIP1",
  "VIP 1 (Table - Sleepy)": "VIP1",
  "VIP2-4 // Do not Chat": "VIP2",
  "VIP2-4 - No Promotions/Yes Comp Points": "VIP2",
  "VIP2-4 - No Promotions/Yes Comp Points // Do not Chat": "VIP2",
  "VIP 2 (Risk - Active)": "VIP2",
  "VIP 2 (Risk - Lapsed)": "VIP2",
  "VIP 2 (Slots - Active)": "VIP2",
  "VIP 2 (Slots - Lapsed)": "VIP2",
  "VIP 2 (Slots - Sleepy)": "VIP2",
  "VIP 2 (Table - Active)": "VIP2",
  "VIP 2 (Table - Lapsed)": "VIP2",
  "VIP 2 (Table - Sleepy)": "VIP2",
  "VIP3": "VIP3",
  "VIP 3": "VIP3",
  "VIP 3 - No Promotions": "VIP3",
  "VIP 3 (Risk - Lapsed)": "VIP3",
  "VIP 3 (Slots - Active)": "VIP3",
  "VIP 3 (Slots - Lapsed)": "VIP3",
  "VIP 3 (Slots - Sleepy)": "VIP3",
  "VIP 3 (Table - Active)": "VIP3",
  "VIP 3 (Table - Lapsed)": "VIP3",
  "VIP 3 (Table - Sleepy)": "VIP3",
  "VIP 4 (Slots - Active)": "VIP4",
  "VIP 4 (Slots - Lapsed)": "VIP4",
  "VIP 4 (Slots - Sleepy)": "VIP4",
  "VIP 4 (Table - Active)": "VIP4",
  "VIP 4 (Table - Lapsed)": "VIP4",
  "VIP 5 - Samantha - No Promotions/No Comp Points": "VIP5",
  "VIP 5 - Samantha - No Promotions/Yes Comp Points": "VIP5",
  "VIP 5 - Samantha's Players": "VIP5",
  "VIP 5 - Samantha's Players // DO NOT CHAT": "VIP5",
  "VIP 5 -  Samantha's Players - Low": "VIP5",
  "VIP 5 (Slots - Active)": "VIP5",
  "VIP 5 (Slots - Lapsed)": "VIP5",
  "VIP 5 (Table - Lapsed)": "VIP5",
  "VIP 6 - Benjamin - No Promotions/No Comp Points": "VIP6",
  "VIP 6 - Benjamin - No Promotions/Yes Comp Points": "VIP6",
  "VIP 6 (Risk - Lapsed)": "VIP6",
  "VIP 6 (Risk - Sleepy)": "VIP6",
  "VIP 6 (Slots - Active)": "VIP6",
  "VIP 6 (Slots - Lapsed)": "VIP6",
  "VIP 6 (Slots - Sleepy)": "VIP6",
  "VIP 6 (Table - Active)": "VIP6",
  "VIP 6 (Table - Lapsed)": "VIP6",
  "VIP 6 (Table - Sleepy)": "VIP6",
  "VIP 7 - Active": "VIP7",
  "VIP 7 - Lapsed": "VIP7",
  "VIP 7 - No Promotions": "VIP7",
  "VIP 7 - No Promotions / Do not Chat": "VIP7",
  "VIP 7 - No Promotions/Yes Comp Points": "VIP7",
  "VIP 7 - Nothing": "VIP7",
  "VIP8 - DO NOT CHAT!": "VIP8",
  "VIP 8 - Weekly & Comps Only": "VIP8",
  "VIP 9 - High Potential Real": "VIP1",
  "VIP ELITE": "VIP8",
  "VIP EXTRA FOCUS": "VIP1",
  "VIP Lapsed 3": "VIP1",
  "VIP - NWH": "NWH",
  "VIP - RISK BENNY": "VIP2",
  "VIP - RISK DANNY": "VIP6",
  "VIP - RISK OLIVIER": "VIP4",
  "VIP 9 - High Potential New Real": "VIP9",
  "VIP 2 (Risk - Lapsed) ": "VIP2",
  "VIP 1 (No Docs / No WD) ": "VIP1",
  "Bonus Player - Medium ": "VIP2",
  "CB or High Risk on Signup ": "Risk",
  "EN - VIP BRONZE - Lapsed": "VIP2",
  "Fake Reg ": "CLOSED ACCOUNTS",
  "Lapsed 4 ": "VIP1",
  "Laure_VIP ": "VIP1",
  "New Real": "Real",
  "New Real 2": "Real",
  "New Real 2 - Slots": "Real",
  "New Real 2 - Table": "Real",
  "New Real 3 ": "Real",
  "New Real 3 - Slots": "Real",
  "New Real 3  - Table": "Real",
  "New Real 3 - Table": "Real",
  "New Real 3 - Table ": "Real",
  "New Real 3": "Real",
  "FR - Star": "VIP1",
  "FR - Star ": "VIP1",
  "EN - VIP SILVER": "VIP4",
  "EN - VIP SILVER - NO PROMOTIONS": "VIP4",
  "DE - VIP BRONZE - NO PROMOTIONS": "VIP3",
  "EN - VIP BRONZE": "VIP3",
  "EN - VIP BRONZE - Sleepy": "VIP3",
  "EN - VIP DIAMOND": "VIP6",
  "EN - VIP DIAMOND - Sleepy": "VIP6",
  "EN - VIP GOLD": "VIP5",
  "EN - VIP SILVER - Lapsed": "VIP4",
  "FR - VIP BRONZE": "VIP3",
  "LANG - VIP BRONZE - NO PROMOTIONS": "VIP3",
  " TEST SUPER USER": "TEST",
  "New Fun 3 - Table ": "Fun",
  "Bonus Player - High": "NoAutoChipper",
  "* white prestige": "VIP1",
  "inactive": "VIP1",
  "depositor base": "VIP1",
  "gold": "VIP1",
  "vip blue": "VIP1",
  "high risk": "NWH",
  "bronze 2018": "VIP1",
  "new real: 12 day+": "Real",
  "* skilled player": "VIP1",
  "elite": "VIP8",
  "vip white": "VIP1",
  "vip diamond": "VIP1",
  "skilled player": "VIP1",
  "platinum": "VIP1",
  "bonus limited": "VIP1",
  "potential abuse: wagering": "VIP1",
  "cross market": "VIP1",
  "vip purple": "VIP1",
  "* bonus hunter": "NWH",
  "manual reaquire": "NWH",
  "manual reaquire: cb": "NWH",
  "banned: charge backs": "NWH",
  "cashouts likely": "NWH",
  "depositor base 2": "VIP1",
  "premier": "VIP8",
  "chargeback": "NWH",
  "daily free spins! september 2014": "VIP1",
  "vip yellow": "VIP1",
  "vip green": "VIP1",
  "* vip (brc)": "VIP1",
  "silver 2018": "VIP1",
  "vip account": "VIP1",
  "vip10": "VIP10",
  "* special bonuses only": "VIP7",
  "* vip lv 1 (bronze beach)": "VIP1",
  "vip 1": "VIP1",
  "banned: jayden": "NWH",
  "daily free spins! august 2014": "VIP1",
  "gold 2018": "VIP1",
  "vip 4 (table - sleepy)": "VIP4",
  "problem gambler": "NWH",
  "vip 5 - samantha's players - low": "VIP5",
  "* vip lv 5 (jet set society member)": "VIP5",
  "vip2-4 - no promotions/yes comp // medium": "VIP4",
  "VIP ELITE YD": "VIP8",
  "New Real YD": "REAL",
  "* Bonus Hunter": "Real",
  "* Skilled Player": "Real",
  "* Special Bonuses Only": "Real",
  "* VIP (BRC)": "Real",
  "* VIP Lv 1 (Bronze Beach)": "Real",
  "* White Prestige": "Real",
  "BONUS LIMITED": "Real",
  "Banned: Charge Backs": "Real",
  "Banned: Jayden": "Real",
  "Bronze": "VIP1",
  "Bronze 2018": "VIP1",
  "CROSS MARKET": "Real",
  "Cashouts Likely": "Real",
  "Chargeback": "Real",
  "Daily Free Spins! August 2014": "Real",
  "Daily Free Spins! September 2014": "Real",
  "Depositor Base": "Real",
  "Depositor Base 2": "Real",
  "Elite": "VIP6",
  "Gold": "VIP1",
  "Gold 2018": "VIP1",
  "High Risk": "VIP1",
  "Inactive": "Real",
  "Manual Reaquire": "Real",
  "Manual Reaquire: CB": "Real",
  "New Real F1": "Real",
  "New Real: 12 Day+": "Real",
  "Non RSA": "Real",
  "Non VIP 1": "Real",
  "Non VIP 2": "Real",
  "PREMIER": "VIP6",
  "Platinum": "VIP1",
  "Potential Abuse: Wagering": "Real",
  "Problem Gambler": "Real",
  "Prom": "Real",
  "Silver": "VIP1",
  "Silver 2018": "VIP1",
  "Skilled Player": "VIP1",
  "TEST SUPER USER": "Real",
  "VIP 1": "VIP1",
  "VIP 4 (Table - Sleepy)": "VIP4",
  "VIP 5 - Samantha's Players - Low": "VIP5",
  "VIP Account": "VIP1",
  "VIP BLUE": "VIP1",
  "VIP DIAMOND": "VIP1",
  "VIP GREEN": "VIP1",
  "VIP PURPLE": "VIP1",
  "VIP WHITE": "VIP1",
  "VIP YELLOW": "VIP1",
  "VIP10": "VIP10",
  "VIP2-4 - No Promotions/Yes Comp // Medium": "VIP2",
  "ZAR Big Winner": "VIP1",
  "ZAR Never Deposited": "VIP1",
  "ZAR Suspended Duplicates": "VIP1"
}).find(([key, value]) => key.toLowerCase().trim() === user_class.toLowerCase().trim())?.[1]?.toUpperCase();

@Injectable({
  providedIn: 'root'
})
export class ChatwootService {

  private scriptLoaded = false;
  private chatwootReady$ = new ReplaySubject<void>(1) //replay last "ready" signal

  brandWebsiteToken: string | undefined;
  userIdentifier: string | undefined;

  private playerLocation = "Website"; // This indicates the location of the player, e.g. "Website (Support Page)"

  countryOptions: {name: string, code: string}[] = [];



  constructor(
    private configs: ConfigService,
    private titleService: TitleService
  ) {
    this.brandWebsiteToken = this.configs.chatwoot_brandWebsiteToken;
    this.userIdentifier = this.configs.chatwoot_userIdentifier;

    this.countryOptions = countryData;



    this.titleService.userLocation$.subscribe(title => {
      //when navigation happens, we set title and userLocation in BS in titleService to rival compatible thingy
      this.playerLocation = title;

      if ((window as any)['$chatwoot']) {
        (window as any)['$chatwoot'].setCustomAttributes({
          location: this.playerLocation
        });
      }
    });

  }

  loadChatwoot() {
    if (this.scriptLoaded) return;

    const BASE_URL = 'https://support.0x6e.com';
    const script = document.createElement('script');
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.onload = () => {
      (window as any).chatwootSDK.run({
        websiteToken: this.brandWebsiteToken,
        baseUrl: BASE_URL,
      });
    };
    document.head.appendChild(script);
    this.scriptLoaded = true;
    window.addEventListener('chatwoot:ready', () => {
      this.chatwootReady$.next();
    })
  }


  setUser(user: UserModel){
    this.chatwootReady$.subscribe(()=>{
      const $chatwoot = (window as any)['$chatwoot'];

      $chatwoot.setUser(user.id.toString(), {
        name: `${user.fname} ${user.lname}`, // Name of the user
        //  avatar_url: "", // Avatar URL
        email: user.email, // Email of the user
        identifier_hash: this.userIdentifier ? this.encrypt(user.id.toString()): "", // Identifier Hash generated based on the webwidget hmac_token
        phone_number: `+${user.phone}`, // Phone Number of the user - should be of E.164 format
        //  description: "", // description about the user
        country_code: this.getUserCountryCode(user.country), // Two-letter country code
        city: user.city, // City of the user
        // company_name: "login here...", // company name
        // social_profiles: {
        //   twitter: "", // Twitter user name
        //   linkedin: "", // LinkedIn user name
        //   facebook: "", // Facebook user name
        //   github: "", // Github user name
        // },
        // });
    })

      $chatwoot.setCustomAttributes({
        user_class: user.userClass,
        user_group: getUserGroup(user.userClass),
        backoffice_link: `https://admin.casinocontroller.com/player-details?id=${user.id}`,
        location: this.playerLocation //todo maybe we dont need to add this <-> sept 16: we only see 'initialized from' not during navigation
      });

    })

  }

  resetUser(){
    //we should do this on log out according to chatwoot docs
    this.chatwootReady$.subscribe(()=> {
      const $chatwoot = (window as any)['$chatwoot'];

      $chatwoot.reset();
    })

  }



  getUserCountryCode(countryName?: string){
    if (countryName){
      const country = this.countryOptions.find(c=>c.name === countryName)
      if(country) {
        return country.code
      }
    }
    return ""
  }

  // generateIdentifierHash(){
  //   const crypto = require('crypto');
  //   const key = '<webwidget-hmac-token>';
  //   const message = this.userIdentifier;
  //   const hash = crypto.createHmac('sha256', key).update(message).digest('hex');
  // }

  //crypto js to hash/encrypt data
  private encrypt(txt: string): string {
    const secret: string = this.userIdentifier ?? "1234567890"
    const hash = CryptoJS.HmacSHA256(txt, secret)
    // const result = CryptoJS.enc.Hex.stringify(hash);
    // console.log(result)
    // return result
    return CryptoJS.enc.Hex.stringify(hash)
  }







}
